module.exports = __webpack_public_path__ + "img/45_ProLabel_Inox.f3c16020.png";